import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emitAll3riqz9vrzwab0 as emitAll } from '../Channels.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
  produce3s4oh9balbl5b as produce,
} from '../../channels/Produce.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope16v8y7h9n9146 as coroutineScope,
} from '../../CoroutineScope.mjs';
import { BufferOverflow_SUSPEND_getInstance31wn3v83onf3w as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineStart_ATOMIC_getInstance1bb1yqu2k5wg1 as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instance2zr761y43akub as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { newCoroutineContext1x74axajiiptk as newCoroutineContext } from '../../CoroutineContext.mjs';
import { Key_instance1cmljiecd0y8y as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { SendingCollector33jb503i6hglm as SendingCollector } from './SendingCollector.mjs';
import { NopCollector2h4omm21qc7hq as NopCollector } from './NopCollector.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from '../../internal/ThreadContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, it, $completion) {
  var tmp = $this.y1f_1.h1d(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  var tmp = emitAll($this.z1f_1, $this.a1g_1.p1d($this$coroutineScope), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
function ChannelFlow$_get_collectToFun_$slambda_j53z2e() {
  if (ChannelFlow$_get_collectToFun_$slambda_j53z2eClass === VOID) {
    class $ {
      constructor(this$0) {
        this.y1f_1 = this$0;
      }
      b1g(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
      }
      ud(p1, $completion) {
        return this.b1g((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$_get_collectToFun_$slambda_j53z2eClass = $;
  }
  return ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
}
function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0) {
  var i = new (ChannelFlow$_get_collectToFun_$slambda_j53z2e())(this$0);
  var l = (it, $completion) => i.b1g(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlow$collect$slambdaClass;
function ChannelFlow$collect$slambda() {
  if (ChannelFlow$collect$slambdaClass === VOID) {
    class $ {
      constructor($collector, this$0) {
        this.z1f_1 = $collector;
        this.a1g_1 = this$0;
      }
      c1g($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$collect$slambdaClass = $;
  }
  return ChannelFlow$collect$slambdaClass;
}
function ChannelFlow$collect$slambda_0($collector, this$0) {
  var i = new (ChannelFlow$collect$slambda())($collector, this$0);
  var l = ($this$coroutineScope, $completion) => i.c1g($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.i1d_1 = context;
        this.j1d_1 = capacity;
        this.k1d_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      l1d() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this);
      }
      m1d() {
        return this.j1d_1 === -3 ? -2 : this.j1d_1;
      }
      n1d(context, capacity, onBufferOverflow) {
        // Inline function 'kotlinx.coroutines.assert' call
        var newContext = context.om(this.i1d_1);
        var newCapacity;
        var newOverflow;
        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          newCapacity = capacity;
          newOverflow = onBufferOverflow;
        } else {
          var tmp;
          if (this.j1d_1 === -3) {
            tmp = capacity;
          } else if (capacity === -3) {
            tmp = this.j1d_1;
          } else if (this.j1d_1 === -2) {
            tmp = capacity;
          } else if (capacity === -2) {
            tmp = this.j1d_1;
          } else {
            // Inline function 'kotlinx.coroutines.assert' call
            // Inline function 'kotlinx.coroutines.assert' call
            var sum = this.j1d_1 + capacity | 0;
            tmp = sum >= 0 ? sum : 2147483647;
          }
          newCapacity = tmp;
          newOverflow = this.k1d_1;
        }
        if (equals(newContext, this.i1d_1) && newCapacity === this.j1d_1 && newOverflow.equals(this.k1d_1))
          return this;
        return this.g1d(newContext, newCapacity, newOverflow);
      }
      p1d(scope) {
        return produce(scope, this.i1d_1, this.m1d(), this.k1d_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.l1d());
      }
      b1d(collector, $completion) {
        return coroutineScope(ChannelFlow$collect$slambda_0(collector, this), $completion);
      }
      q1d() {
        return null;
      }
      toString() {
        var props = ArrayList().m2(4);
        var tmp0_safe_receiver = this.q1d();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.n2(tmp0_safe_receiver);
        }
        if (!(this.i1d_1 === EmptyCoroutineContext_instance)) {
          props.n2('context=' + toString(this.i1d_1));
        }
        if (!(this.j1d_1 === -3)) {
          props.n2('capacity=' + this.j1d_1);
        }
        if (!this.k1d_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.n2('onBufferOverflow=' + this.k1d_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    protoOf($).o1d = fuse$default;
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, [FusibleFlow()], [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.n1d(context, capacity, onBufferOverflow) : $super.n1d.call(this, context, capacity, onBufferOverflow);
}
var FusibleFlowClass;
function FusibleFlow() {
  if (FusibleFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FusibleFlow', VOID, VOID, VOID, [1]);
    FusibleFlowClass = $;
  }
  return FusibleFlowClass;
}
var ChannelFlowOperatorImplClass;
function ChannelFlowOperatorImpl() {
  if (ChannelFlowOperatorImplClass === VOID) {
    class $ extends ChannelFlowOperator() {
      constructor(flow, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -3 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(flow, context, capacity, onBufferOverflow);
      }
      g1d(context, capacity, onBufferOverflow) {
        return new (ChannelFlowOperatorImpl())(this.k1g_1, context, capacity, onBufferOverflow);
      }
      l1g(collector, $completion) {
        return this.k1g_1.b1d(collector, $completion);
      }
    }
    initMetadataForClass($, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
    ChannelFlowOperatorImplClass = $;
  }
  return ChannelFlowOperatorImplClass;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  var tmp = $this.m1g_1.l1g(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.rc();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this), $completion);
}
function *_generator_collect__dlomyy($this, collector, $completion) {
  if ($this.j1d_1 === -3) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var collectContext = $completion.rc();
    var newContext = newCoroutineContext(collectContext, $this.i1d_1);
    if (equals(newContext, collectContext)) {
      var tmp = $this.l1g(collector, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      return Unit_instance;
    }
    if (equals(newContext.hd(Key_instance), collectContext.hd(Key_instance))) {
      var tmp_0 = collectWithContextUndispatched($this, collector, newContext, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      return Unit_instance;
    }
  }
  var tmp_1 = protoOf(ChannelFlow()).b1d.call($this, collector, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
function ChannelFlowOperator$collectWithContextUndispatched$slambda() {
  if (ChannelFlowOperator$collectWithContextUndispatched$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.m1g_1 = this$0;
      }
      n1g(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      ud(p1, $completion) {
        return this.n1g((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlowOperator$collectWithContextUndispatched$slambdaClass = $;
  }
  return ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0) {
  var i = new (ChannelFlowOperator$collectWithContextUndispatched$slambda())(this$0);
  var l = (it, $completion) => i.n1g(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowOperatorClass;
function ChannelFlowOperator() {
  if (ChannelFlowOperatorClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(flow, context, capacity, onBufferOverflow) {
        super(context, capacity, onBufferOverflow);
        this.k1g_1 = flow;
      }
      h1d(scope, $completion) {
        return this.l1g(new (SendingCollector())(scope), $completion);
      }
      b1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy.bind(VOID, this, collector), $completion);
      }
      toString() {
        return toString(this.k1g_1) + ' -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
    ChannelFlowOperatorClass = $;
  }
  return ChannelFlowOperatorClass;
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector();
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (UndispatchedContextCollector())(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlinx.coroutines.withCoroutineContext' call
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
  var completion = new (StackFrameContinuation())($completion, newContext);
  return startCoroutineUninterceptedOrReturnGeneratorVersion(block, value, completion);
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  var tmp = $this.o1g_1.s1d(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var UndispatchedContextCollector$emitRef$slambdaClass;
function UndispatchedContextCollector$emitRef$slambda() {
  if (UndispatchedContextCollector$emitRef$slambdaClass === VOID) {
    class $ {
      constructor($downstream) {
        this.o1g_1 = $downstream;
      }
      p1g(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      ud(p1, $completion) {
        return this.p1g((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UndispatchedContextCollector$emitRef$slambdaClass = $;
  }
  return UndispatchedContextCollector$emitRef$slambdaClass;
}
function UndispatchedContextCollector$emitRef$slambda_0($downstream) {
  var i = new (UndispatchedContextCollector$emitRef$slambda())($downstream);
  var l = (it, $completion) => i.p1g(it, $completion);
  l.$arity = 1;
  return l;
}
var UndispatchedContextCollectorClass;
function UndispatchedContextCollector() {
  if (UndispatchedContextCollectorClass === VOID) {
    class $ {
      constructor(downstream, emitContext) {
        this.q1g_1 = emitContext;
        this.r1g_1 = threadContextElements(this.q1g_1);
        var tmp = this;
        tmp.s1g_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream);
      }
      s1d(value, $completion) {
        return withContextUndispatched(this.q1g_1, value, this.r1g_1, this.s1g_1, $completion);
      }
    }
    initMetadataForClass($, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector()], [1]);
    UndispatchedContextCollectorClass = $;
  }
  return UndispatchedContextCollectorClass;
}
var StackFrameContinuationClass;
function StackFrameContinuation() {
  if (StackFrameContinuationClass === VOID) {
    class $ {
      constructor(uCont, context) {
        this.t1g_1 = uCont;
        this.u1g_1 = context;
      }
      rc() {
        return this.u1g_1;
      }
      tc(result) {
        this.t1g_1.tc(result);
      }
    }
    initMetadataForClass($, 'StackFrameContinuation', VOID, VOID, [Continuation()]);
    StackFrameContinuationClass = $;
  }
  return StackFrameContinuationClass;
}
//region block: exports
export {
  fuse$default as fuse$default193jw8jxgbygs,
  ChannelFlowOperatorImpl as ChannelFlowOperatorImpl3gjkp847e0ebc,
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
  FusibleFlow as FusibleFlow2tgh9s2p1kryd,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
